import http from '@/utils/http';
import axios from 'axios';
const baseUrl = '/relatorio-rastreabilidade';

export default {
    inserirRelatorios(data) {
        return http.post({
            url: baseUrl,
            data: data,
            lockScreen: false
        });
    },
    atualizarRelatorios(data) {
        return http.put({
            url: baseUrl,
            data: data,
            lockScreen: false
        });
    },
    buscarRelatorios(paginacao, numeroContrato = null) {
        const temNumeroContrato = `&numeroContrato=${numeroContrato}`;
        const temOrdenacao = paginacao.ordenacao
            ? `&sort=${paginacao.ordenacao}`
            : '';
        return http.get({
            url:
                baseUrl +
                `?page=${paginacao.pagina}&size=${paginacao.itensPorPagina}` +
                temNumeroContrato +
                temOrdenacao,
            lockScreen: false
        });
    },
    buscarRelatorioIndividual(relatorioId) {
        return http.get({
            url: baseUrl + `/detalhe/${relatorioId}`,
            lockScreen: false
        });
    },
    deletarRelatorios(relatorioId) {
        return http.post({
            url: baseUrl + `/inativar-relatorio/${relatorioId}`,
            lockScreen: false
        });
    },
    buscarResumoRelatorios(relatorioId) {
        return http.get({
            url: baseUrl + `/resumo/${relatorioId}`,
            lockScreen: true
        });
    },
    buscarHeaderPlanilhaUpload(planilha) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${baseUrl}/lote/processa-cabecalho-planilha`;

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    validarPlanilhaTerritorio(cabecalhoMapeado, planilha) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${baseUrl}/lote/valida-planilha`;

        const formData = new FormData();

        for (const key in cabecalhoMapeado) {
            formData.append(`${cabecalhoMapeado[key]}`, key);
        }
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    realizarElegibilidadeLote(dados) {
        return http.post({
            url: baseUrl + '/lote/analisa-elegibilidade',
            data: dados,
            lockScreen: false,
            lockMessage: 'Buscando informações'
        });
    },
    compartilharRelatorio(relatorioId) {
        return http.patch({
            url: baseUrl + `/compartilhar/${relatorioId}`,
            data: {},
            lockScreen: true
        });
    },
    compartilharRelatorioEmail(relatorioId, email) {
        return http.post({
            url: baseUrl + `/compartilhar/email`,
            data: {
                relatorioId,
                email
            },
            lockScreen: true
        });
    }
};
